import NATIONALITIES, { getFlagUrl } from '../data/nationalities';

export default function NationalitySelect({ value, onChange, disabled, language = 'ja', className = '', dataTestId }) {
  const placeholderText = language === 'ja' ? '選択してください' : 'Select';

  if (disabled) {
    const selected = NATIONALITIES.find(c => c.ja === value);
    const flagUrl = selected ? getFlagUrl(selected.code) : null;
    return (
      <div className={`flex items-center gap-2 w-full rounded-md border border-input bg-background px-3 py-2 text-sm opacity-70 ${className}`}>
        {flagUrl && <img src={flagUrl} alt="" width={20} height={15} className="inline-block shrink-0" style={{objectFit:'cover'}} />}
        <span>{value || '-'}</span>
      </div>
    );
  }

  return (
    <div className="relative">
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full rounded-md border border-input bg-background pl-9 pr-3 py-2 text-sm appearance-none ${className}`}
        data-testid={dataTestId}
      >
        <option value="">{placeholderText}</option>
        {NATIONALITIES.map(c => (
          <option key={c.ja} value={c.ja}>
            {language === 'ja' ? c.ja : `${c.en} (${c.ja})`}
          </option>
        ))}
      </select>
      {/* Show flag for selected value */}
      <SelectedFlag value={value} />
    </div>
  );
}

function SelectedFlag({ value }) {
  const selected = NATIONALITIES.find(c => c.ja === value);
  const flagUrl = selected ? getFlagUrl(selected.code) : null;
  return (
    <span className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none flex items-center">
      {flagUrl ? (
        <img src={flagUrl} alt="" width={20} height={15} className="inline-block" style={{objectFit:'cover'}} />
      ) : (
        <span className="inline-block w-5 h-[15px] bg-gray-200 rounded-sm" />
      )}
    </span>
  );
}
